import { RelatedItems } from "@/admin/RelatedItems.tsx";
import { ImpersonateModalContent } from "@/admin/users/ImpersonationBlock.tsx";
import { MfaModalContent } from "@/admin/users/MfaBlock.tsx";
import type { GQUserItem } from "@/admin/users/UsersTable.tsx";
import { WModalButton } from "@/components/button/WToolButton.tsx";
import { WModal } from "@/components/modal/WModal.tsx";
import { Toolbar } from "@/components/Toolbar.tsx";

export function UserToolbar({ item }: { item: GQUserItem }) {
    return (
        <Toolbar>
            <RelatedItems id={item.id} from="fromUser" />

            <WModal button={<WModalButton label="Impersonate" size="md" icon="jp-swap-icon" />}>
                <ImpersonateModalContent item={item} />
            </WModal>

            <WModal button={<WModalButton label="Manage MFA" size="md" icon="i-lucide:user-lock" />}>
                <MfaModalContent item={item} />
            </WModal>
        </Toolbar>
    );
}
